export default "__VITE_ASSET__CbyydzD1__"